import { useResponsiveWidth } from '../../hooks/useResponsiveWidth';

export const ResponsiveWidth = ({
  children,
}: {
  children: (args: { width: number }) => React.ReactNode;
}) => {
  const { ref: responsiveWidthRef, width } = useResponsiveWidth();

  return (
    <div ref={responsiveWidthRef}>
      {children({
        width,
      })}
    </div>
  );
};
